import React from 'react'

const OptionValuesCard = ({options}) => {
  return (
    <div className='card rounded-3'>
 
        <div className='card-body'>
                   <h4 className='font14 font700'>الخيارات</h4>
           {options.map((option)=>(<div key={option.id}>
                  <h4 className='font14 desc text-start mt-3'>{option.option.name} </h4>

                  <div >{option.option_values.map((value)=>(<div>
                    <h4 className='font14'>{value.product_value.name}</h4>
                    <p className='text-green'>{value.price} </p>
                  </div>))}</div>
            </div>)) }
       
        </div>
        
    </div>
  )
}

export default OptionValuesCard